import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";
import { toast } from "react-toastify";

export const mailApi = {
  async getMails(id) {
    try {
      const res = await request(API_ROUTES.getGeneralData("Mail", id), { method: "GET", });
      const data = await res.json();

      if (data?.success === false) {
        toast.error(data.message || "Ocurrió un error.");
        return [];
      }

      return data.data || [];
    } catch (err) {
      console.error("Error al cargar direcciones:", err);
      return [];
    }
  },

  async saveMail(payload) {
    try {
      const isUpdate = !!payload.id;
      const res = await request(API_ROUTES.saveMail, {
        method: isUpdate ? "PUT" : "POST",
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.success === false) {
        toast.error(data.message || "Ocurrió un error.");
        return false;
      }

      return true;
    } catch (err) {
      console.error("Error al guardar dirección:", err);
      throw err;
    }
  },

  async inactiveMail(id) {
    try {
      const res = await request(API_ROUTES.updateGeneralData, {
        method: "PUT",
        body: JSON.stringify({ id, tipo: "Mail" }),
      });

      const data = await res.json();

      if (data?.success === false) {
        toast.error(data.message || "Ocurrió un error.");
        return false;
      }

      return true;
    } catch (err) {
      console.error("Error al eliminar dirección:", err);
      return false;
    }
  },
};
